<template>
  <div>
    <b-card
      class="mb-0"
      title=""
    >
      <validation-observer
        ref="createDriveLinkForm"
        #default="{ invalid }"
      >
        <b-form @submit.prevent>
          <!-- Batch -->
          <b-col cols="12">
            <b-form-group
              label="Batch"
              label-for="batch"
            >
              <validation-provider
                #default="{ errors }"
                name="Batch"
                vid="batch"
                rules="required"
              >
                <v-select
                  id="register-batch"
                  v-model="form.batch"
                  placeholder="Select Batch"
                  :options="batch"
                  label="label"
                  :reduce="(option) => option.value"
                  :class="{ 'is-invalid': errors.length > 0 }"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <!-- Intake -->
            <b-form-group
              label="Intake"
              label-for="intake"
            >
              <validation-provider
                #default="{ errors }"
                name="Intake"
                vid="intake"
                rules="required"
              >
                <v-select
                  id="register-intake"
                  v-model="form.intake"
                  placeholder="Select Intake"
                  :options="intake"
                  label="label"
                  :reduce="(option) => option.value"
                  :class="{ 'is-invalid': errors.length > 0 }"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <!-- Drive Link -->
            <b-form-group
              label="Drive Link"
              label-for="drive_link"
            >
              <validation-provider
                #default="{ errors }"
                v-model="form.drive_link"
                name="Drive Link"
                vid="drive_link"
                rules="required|url"
              >
                <b-form-input
                  id="register-link"
                  v-model="form.drive_link"
                  placeholder="Enter Google Drive Link"
                  :state="errors.length > 0 ? false : null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <!-- Month -->
            <b-form-group
              label="Month"
              label-for="month"
            >
              <validation-provider
                #default="{ errors }"
                name="Month"
                vid="month"
                rules="required"
              >
                <v-select
                  id="select-month"
                  v-model="form.month"
                  :options="months"
                  label="label"
                  :reduce="(option) => option.value"
                  :class="{ 'is-invalid': errors.length > 0 }"
                  placeholder="Select Month"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <!-- Submit Button -->
          <b-form-group>
            <b-form-input
              id="hidden-input"
              type="text"
              hidden
            />
          </b-form-group>

          <b-button
            variant="primary"
            block
            type="submit"
            :disabled="invalid"
            @click="createDriveLink()"
          >
            Submit
          </b-button>
        </b-form>
      </validation-observer>
    </b-card>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import vSelect from 'vue-select'
import lmsDriveApi from '@/Api/Modules/lmsDriveLinks'
import {
  BCard,
  BForm,
  BButton,
  BFormInput,
  BFormGroup,
  BCol,
} from 'bootstrap-vue'
import { required, url } from '@validations'

export default {
  name: 'AddLmsDriveLink',
  components: {
    vSelect,
    BCard,
    BForm,
    BButton,
    BFormInput,
    BFormGroup,
    BCol,
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      form: {},
      batch: [
        { label: 'B03', value: 'B03' },
        { label: 'B04', value: 'B04' },
        { label: 'B05', value: 'B05' },
        { label: 'B06', value: 'B06' },
        { label: 'B07', value: 'B07' },
      ],
      intake: [
        { label: '01', value: '01' },
        { label: '02', value: '02' },
      ],
      months: [
        { label: '01', value: 1 },
        { label: '02', value: 2 },
        { label: '03', value: 3 },
        { label: '04', value: 4 },
        { label: '05', value: 5 },
        { label: '06', value: 6 },

      ],
      required,
      url,
    }
  },
  methods: {
    async createDriveLink() {
      if (await this.$refs.createDriveLinkForm.validate()) {
        await this.$vs.loading({ scale: 0.8 })
        this.form.link_status = 1

        await lmsDriveApi
          .createDriveLink(this.form)
          .then(() => {
            this.$vs.loading.close()

            this.$router.push({ name: 'lmsLinks' }) // upon successful submission the table loads
          })
          .catch(() => {
            this.$vs.loading.close()
            this.$vs.notify({
              title: 'Error',
              text: 'Failed to add LMS Drive Link',
              color: 'danger',
            })
          })
      }
    },
  },
}
</script>
